import { AiIntegrationView } from "shared/AiIntegration/useSearchAiIntegrations/gql";

import { SPACELIFT_DEFAULT_LABEL } from "./constants";

const getIntegrationName = (selectedIntegration: AiIntegrationView | undefined) => {
  if (!selectedIntegration) {
    return undefined;
  }

  return selectedIntegration.isSpaceliftProvided
    ? SPACELIFT_DEFAULT_LABEL
    : selectedIntegration.name;
};

const getModelName = (
  selectedIntegration: AiIntegrationView | undefined,
  model: string | undefined
) => {
  if (!selectedIntegration || !model) {
    return undefined;
  }

  return selectedIntegration.modelDetails.find((entry) => entry.id === model)?.name ?? model;
};

export const formatModelName = (
  selectedIntegration: AiIntegrationView,
  model: string | undefined
) => {
  if (!model) {
    return getIntegrationName(selectedIntegration);
  }

  return getModelName(selectedIntegration, model);
};

export const getTooltipContent = (
  selectedIntegration: AiIntegrationView | undefined,
  model: string | undefined
) => {
  if (!selectedIntegration) {
    return undefined;
  }

  const integrationName = getIntegrationName(selectedIntegration);

  return model ? (
    <>
      Integration: {integrationName}
      <br />
      Model: {getModelName(selectedIntegration, model)}
    </>
  ) : (
    `Integration: ${integrationName}`
  );
};
